<template lang="pug">
    v-container
        br
        v-row
            v-html(style="width:100%!important;text-align:center") <h1>Documentación</h1>
        br
        hr
        br
        v-row
            v-card.mx-10(width="100%",elevation="0")
                v-card-title
                    h2(v-html="") {{$t('techreference')}}
                v-card-subtitle 
                    a(@click="openLink('http://docs.nufi.mx')") {{$t('gotoapireference')}} 
                hr
                v-card-text
                    ul
                        li
                            a(@click="openLink('http://docs.nufi.mx')") {{$t('howtoobtainapikey')}}
                        li
                            a(@click="openLink('http://docs.nufi.mx')") {{$t('knownufiapplications')}}
                        li
                            a(@click="openLink('http://docs.nufi.mx')") {{$t('mostusedcomponents')}}

        v-row
            v-card.mx-10(width="100%",elevation="0")
                v-card-title
                    h2 {{$t('implementationguidesinline')}}
                v-card-subtitle 
                    a(@click="openLink('http://guias.nufi.mx')") {{$t('gotoimplentationguidesportal')}}
                hr
                v-card-text
                    ul
                        li 
                            a(@click="openLink('http://guias.nufi.mx')") {{$t('implemententerprisesolution')}}
                        li
                            a(@click="openLink('http://guias.nufi.mx')") {{$t('guideforkyc')}}
</template>
<script>
import link from '@/mixins/link';
export default {
  mixins: [link],
}
</script>